import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import {
  getDNIField,
  getHealthPlanSectionField,
  getInsuranceField,
  getSameSuscriptorField,
  getOncologicalAgreementField,
  getComplementaryInsuranceField
} from './fields';

import InsuranceService from '../../../services/insurance-service';
import HealthPlanService from '../../../services/health-plan-service';
import { PATIENT_FORM_TITLE } from '../../../libraries/texts';
import { INSURANCE_WITH_PLAN } from '../../../libraries/constants';

import { patient as styles } from '../styles';

const PatientForm = props => {
  const { values, classes, handleBlur, errors, touched, setFieldValue, setFieldTouched } = props;
  const [showPlanSection, setShowPlanSection] = useState(false);
  const [insurances, setInsurances] = useState([]);
  const [healthPlans, setHealthPlan] = useState([]);

  const getRequests = async () => {
    const insuranceList = await InsuranceService.getAll();
    setInsurances(insuranceList);
    const healthPlanList = await HealthPlanService.getAll();
    setHealthPlan(healthPlanList);
  };

  useEffect(() => {
    getRequests();
  }, []);

  useEffect(() => {
    const dniValue = values['patientSuscriptorCb'] ? values['suscriptorDni'] : '';
    const dniNumberValue = values['patientSuscriptorCb'] ? values['suscriptorDniNumber'] : '';
    setFieldValue('patientDni', dniValue);
    setFieldValue('patientDniNumber', dniNumberValue);
    setFieldTouched('patientDni', false);
  }, [values['patientSuscriptorCb']]);

  useEffect(() => {
    const value = values['patientInsurance'];
    let showPlan = false;
    if (value && value.code && value.name.toUpperCase() === INSURANCE_WITH_PLAN) {
      showPlan = true;
    }
    setShowPlanSection(showPlan);
    if (!showPlan) {
      setFieldValue(`${prefix}PlanSection`, '');
    }
  }, [values['patientInsurance']]);
  const fieldProps = {
    handleBlur,
    classes,
    touched,
    errors,
    values,
    setFieldValue,
    setFieldTouched
  };
  const prefix = 'patient';

  return (
    <Card className={classes.card}>
      <CardHeader title={PATIENT_FORM_TITLE} className={classes.cardTitle} />
      <CardContent className={classes.cardContent}>
        {values ? (
          <React.Fragment>
            <div className={classes.checkboxContainer}>
              {getSameSuscriptorField({
                ...fieldProps,
                name: `${prefix}SuscriptorCb`,
                label: `Igual Suscriptor`
              })}
              {getOncologicalAgreementField({
                ...fieldProps,
                name: `${prefix}OncologicalAgreementCb`,
                label: `Convenio Oncológico FALP`
              })}
              {getComplementaryInsuranceField({
                ...fieldProps,
                name: `${prefix}ComplementaryInsuranceCB`,
                label: `Seguro complementario`
              })}
            </div>

            <Divider />

            {getDNIField({
              ...fieldProps,
              name: `${prefix}Dni`,
              label: `Rut Paciente`,
              disabled: values[`${prefix}SuscriptorCb`]
            })}

            <Divider />
            {getInsuranceField({
              ...fieldProps,
              name: `${prefix}Insurance`,
              label: 'Previsión *',
              options: insurances
            })}
            {showPlanSection
              ? getHealthPlanSectionField({
                  ...fieldProps,
                  name: `${prefix}PlanSection`,
                  label: 'Tramo Plan de Salud *',
                  required: true,
                  options: healthPlans
                })
              : ''}
          </React.Fragment>
        ) : (
          ''
        )}
      </CardContent>
    </Card>
  );
};

PatientForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(PatientForm);
